import { render } from "./PartyasDetails.vue?vue&type=template&id=46bb469f&scoped=true"
import script from "./PartyasDetails.vue?vue&type=script&lang=js"
export * from "./PartyasDetails.vue?vue&type=script&lang=js"

import "./PartyasDetails.vue?vue&type=style&index=0&id=46bb469f&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46bb469f"]])

export default __exports__